const GET_CUSTOMER_PROPERTIES = '/property/get-customer-properties';
const GET_CUSTOMER_PROPERTIES_FROM = '/property/get-property-fields';
const SAVE_PROPERTY_FIELD = '/property/save-property-fields';
const GET_CUSTOMER_PROPERTY = '/property/get-customer-property-fields';

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

module.exports = {
    getCustomerProperties: function getCustomerProperties(customerId, tradingNameId,id,type) {
        return window.axios.get(GET_CUSTOMER_PROPERTIES, {
            params: {
                customer_id: customerId,
                trading_id: tradingNameId,
                id: id,
                type: type
            }
        });
    },
    getCustomerProperty: function getCustomerProperty(customerPropertyId, propertyId, custom) {
        return window.axios.get(GET_CUSTOMER_PROPERTY, {
            params: {
                customer_property_id: customerPropertyId,
                property_id: propertyId,
                custom:custom
            }
        });
    },
    getCustomerPropertiesForm: function getCustomerPropertiesForm(propertyId) {
        return window.axios.get(GET_CUSTOMER_PROPERTIES_FROM, {
            params: {
                id: propertyId
            }
        });
    },
    updateCustomerProperty: function updateCustomerProperty(data){
        let form = new FormData();

        buildFormData(form, data);

        return window.axios.post(SAVE_PROPERTY_FIELD, form, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;Content-Type:multipart/form-data; charset=UTF-8'
            }
        });
    },
    storeCustomerPropertyForCustomer: function storeCustomerPropertyForCustomer(data) {

        let form = new FormData();

        buildFormData(form, data);
        return window.axios.post(SAVE_PROPERTY_FIELD, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
};  
